import { type ReactNode } from "react";
import Spacer from "../../Spacer";
import classNames from "classnames";

export interface PageTitleProps {
  className?: string;
  title: ReactNode;
  tag?: keyof JSX.IntrinsicElements;
  linkHelp?: ReactNode;
}

/**
 * @deprecated
 * Please use PageTitle from v2 instead
 */
const PageTitle = (props: PageTitleProps) => {
  const { className, title, tag = "h1", linkHelp } = props;

  const cls = classNames("scha__page-title", className);
  const Tag = tag;

  return (
    <>
      <Tag className={cls}>{title}</Tag>
      {linkHelp && <span className={"scha__page-helpLink"}>{linkHelp}</span>}
      <Spacer className={"scha__page-title__spacer"} />
    </>
  );
};

export default PageTitle;
